import React from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { BodyText } from '@garnish/core';
import { AddressOrder } from '@garnish/location';

import { DeliveryPreferenceType } from '@sg/graphql-schema';

import { useAddressTitle, usePreferencesText } from './hooks';

import type { AddressType } from '@garnish/location';

export const OrderStatusAddress = (props: OrderStatusAddressProps) => {
  const {
    orderType,
    deliveryAddressName,
    deliveryAddressStreet,
    deliveryAddressSecondaryStreet,
    deliveryAddressCity,
    deliveryAddressState,
    deliveryAddressZipCode,
    deliveryAddressNotes,
    deliveryPreference,
    locationName,
    locationAddress,
    locationCity,
    locationState,
    locationZipCode,
    dropoffLocation,
  } = props;

  const addressTitle = useAddressTitle(orderType);
  const deliveryPreferenceText = usePreferencesText(
    deliveryPreference ?? DeliveryPreferenceType.LeaveAtDoor,
  );

  const isDelivery = orderType === 'delivery';

  return (
    // @ts-expect-error TS(2769): No overload matches this call.
    <View dataSet={{ ddPrivacy: isDelivery ? 'mask' : 'mask-user-input' }}>
      <BodyText sizeMatch={['16']} bold style={styles.addressHeader}>
        {addressTitle}
      </BodyText>

      <AddressOrder
        addressType={orderType}
        name={isDelivery ? deliveryAddressName : locationName}
        street={isDelivery ? deliveryAddressStreet : locationAddress}
        city={isDelivery ? deliveryAddressCity : locationCity}
        state={isDelivery ? deliveryAddressState : locationState}
        zipCode={isDelivery ? deliveryAddressZipCode : locationZipCode}
        secondaryStreet={deliveryAddressSecondaryStreet}
        hideIcon
      />

      {dropoffLocation ? (
        <View style={styles.preferences}>
          <BodyText sizeMatch={['14']}>{dropoffLocation}</BodyText>
        </View>
      ) : null}

      {isDelivery ? (
        <View style={styles.preferences}>
          <BodyText sizeMatch={['14']}>{deliveryPreferenceText}</BodyText>

          <BodyText sizeMatch={['14']}>{deliveryAddressNotes}</BodyText>
        </View>
      ) : null}
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  addressHeader: {
    marginBottom: theme.spacing['4'],
  },
  preferences: {
    marginTop: theme.spacing['4'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

export type OrderStatusAddressProps = {
  orderType: AddressType;
  deliveryAddressName?: string;
  deliveryAddressStreet?: string;
  deliveryAddressSecondaryStreet?: string;
  deliveryAddressCity?: string;
  deliveryAddressState?: string;
  deliveryAddressZipCode?: string;
  deliveryAddressNotes?: string;
  deliveryPreference?: DeliveryPreferenceType;
  locationName?: string;
  locationAddress?: string;
  locationCity?: string;
  locationState?: string;
  locationZipCode?: string;
  dropoffLocation?: string;
};
